import { setSpecificMessage, integer } from "valibot";
setSpecificMessage(
  integer,
  (issue) => `Entier invalide: reçu ${issue.received}`,
  "fr"
);